import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=15e30c51"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports